import { faEraser, faTimes } from '@fortawesome/pro-regular-svg-icons';
import Button from '@sharedComponents/Button';
import FlexBox from '@sharedComponents/FlexBox';
import Tag from '@sharedComponents/Tag';
import { useTranslation } from 'react-i18next';

// Tag colours of the chips: the secondary colour with the primary text, both following the brand palette, or
// the frozen lavender, which the brand palette leaves untouched.
const CHIP_COLORS = {
    secondary: { color: 'secondary', textColor: 'branded-primary' },
    lavender: { color: 'lavender', textColor: null },
};

/**
 * Row of removable chips describing the active filters of a table, with a global reset
 * action. Renders nothing when no filter is active. `color` ('secondary' or 'lavender')
 * sets the colour of the chips.
 */
const ActiveFiltersBar = ({ filters = [], color = 'secondary', onRemove, onReset }) => {
    const { t } = useTranslation();

    if (filters.length === 0) return null;

    return (
        <FlexBox
            justifyContent="space-between"
            alignItems="center"
            additionnalStyles={{
                padding: '0 var(--space-m) var(--space-m) var(--space-m)',
            }}
        >
            <FlexBox flexWrap="wrap" gap="xs" alignItems="center">
                {filters.map((filter) => (
                    <Tag
                        key={filter.key}
                        color={CHIP_COLORS[color].color}
                        textColor={CHIP_COLORS[color].textColor}
                        onClick={() => onRemove(filter.key)}
                        icon={faTimes}
                        noTruncate={filter.noTruncate}
                    >
                        {filter.label}
                    </Tag>
                ))}
            </FlexBox>
            <Button ghost icon={faEraser} label={t('Reset filters')} action={onReset} />
        </FlexBox>
    );
};

export default ActiveFiltersBar;
